/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';
import InjectableComponent from '../../../Utility/Component/ComponentReference/InjectableComponent';
import ReelManager from '../../../Reel/ReelManager';

/** Filter for specific paylines. */
@cc._decorator.ccclass
export default class LockedReelFilter extends StreakTrackerFilterBase
{
    private _reelManagerRef: InjectableComponent<ReelManager> = new InjectableComponent<ReelManager>();

    protected setContexts(): void
    {
        this._reelManagerRef.SetContext(ReelManager);
    }

    /** Filters out symbols outside of valid paylines. */
    public Filter = (symbols: ISymbolData[]): ISymbolData[] =>
    { 
        return symbols.filter((x) => { return !this._reelManagerRef.Value.Reels[x.ReelIndex].IsLocked; }); 
    }
}
